import * as React from "react";

import Input from "./Input";
import Source from "./Source";

export default () => (
  <div>
    <Source />
    <Input />
  </div>
);



// WEBPACK FOOTER //
// ./components/Board/Editor/index.tsx